import { render, staticRenderFns } from "./MyProfile-v2.vue?vue&type=template&id=7d2c0b60&scoped=true"
import script from "./MyProfile-v2.vue?vue&type=script&lang=js"
export * from "./MyProfile-v2.vue?vue&type=script&lang=js"
import style0 from "./MyProfile-v2.vue?vue&type=style&index=0&id=7d2c0b60&prod&lang=css"
import style1 from "./MyProfile-v2.vue?vue&type=style&index=1&id=7d2c0b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2c0b60",
  null
  
)

export default component.exports